import React from 'react';
import { Chart } from 'react-google-charts';
import WrapperCard from './WrapperCard';

const options = {
  pieHole: 0.5,
  chartArea: {
    left: 30,
    right: 0,
    top: 0,
    bottom: 0,
  },
  slices: {
    0: { color: '#03045e' },
    1: { color: '#023e8a' },
    2: { color: '#0077b6' },
    3: { color: '#0096c7' },
    4: { color: '#00b4d8' },
    5: { color: '#c5e5eb' },
    6: { color: '#caf0f8' },
    7: { color: '#3aa1c3' },
    8: { color: '#4e91a7' },
    9: { color: '#00b4d8' },
    10: { color: '#0d697b' },
    11: { color: '#1c6d7d' },
    12: { color: '#2c6c79' },
    13: { color: '#164177' },
    14: { color: '#1d395b' },
  },
};

function LineTypeDispersement({ isLoading, data }) {
  const buckets = data?.line_types?.buckets || [];

  const chartData = React.useMemo(() => {
    const preparedData = buckets
      .map(b => {
        return [b.key, b.doc_count];
      })
      .filter(b => Boolean(b[0]));

    return [['LineType', 'Calls'], ...preparedData];
  }, [buckets]);

  return (
    <WrapperCard
      isLoading={isLoading}
      title="Line Type Distribution"
      showHeaderIcon={false}
      contentSkeletons={7}
    >
      <Chart chartType="PieChart" width="100%" height="220px" data={chartData} options={options} />
    </WrapperCard>
  );
}

export default LineTypeDispersement;
